<template>
	<v-card flat  color="transparent" class="pr-2 pl-2">
		<v-dialog v-model="dialog" max-width="460">
			<template v-slot:activator="{ on }">
				<v-btn block small :color="color" dark text v-on="on"><v-icon small class="mr-3">mdi-question-mark</v-icon>Passwort Vergessen</v-btn> 
			</template>
			<v-card>
				<DialogTitle title="Forgot Password" @close="dialog = false"></DialogTitle>
				<v-alert color="green" type="success" dense v-if="success" class="mr-4 ml-4">Please check your email for further instructions</v-alert>
				<v-card-text v-else>
					<v-text-field prepend-icon="mdi-at" label="Email Address" v-model="email"></v-text-field>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn v-if="!success" rounded color="primary" text @click="sendPasswordReset">
						Submit
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>   	
	</v-card>
</template>

<script type="text/javascript">
	import Vuex from "vuex";
	import DialogTitle from "@/components/elements/DialogTitle"
	export default {
		name: "ForgotPassword", 
		props: {
			color: { type: String, default: () => "black"}, 
			trigger: {type: Boolean}
		},
		data: () => {
			return {				
				dialog: null,
				email: null,
				success: false
			}
		},
		components: {
			DialogTitle,
		},
		computed:  {
			...Vuex.mapState({
				auth: state => state.auth,
			})
		},
		methods: {
			sendPasswordReset(){
				this.$store.dispatch("mail/sendPasswordResetEmail", this.email).then(() => {
					this.success = true;
				}).catch(( )=>{
					//
				})
			}
		},
		watch: {
			dialog(){
				if( this.dialog == false ){
					this.$emit("close");
				}
			},
			trigger(){
				if( this.trigger == true ){
					this.dialog = true;
				}
			}
		}
	}
</script>


